import { ReactComponent as AlertWarning } from "assets/AlertWarning.svg";
import Typography from "components/common/Typography";
import { isEmpty } from "lodash";
import { useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { getUserNameWithConditionalCheck } from "utils/SharedUtils";
import "./PlanDetailAccessBanner.scss";

interface Props {
  label?: string;
}
const AccessBanner = (props: Props) => {
  const { label } = props;
  const owners = useAppSelector((state) => state.myPlanDetails.owner);
  const owner = !isEmpty(owners)
    ? getUserNameWithConditionalCheck(owners?.[0]?.displayName, owners?.[0]?.firstName, owners?.[0]?.lastName)
    : "User";
  return (
    <div className="permission-banner">
      <div className="permission-banner-container">
        <AlertWarning />
        <Typography variant={"body2"} changeVariant={false} color={colors.Yellow.Yellow700}>
          {label ??
            `Attention! You are on ${owner}'s, plan. Any changes you make will alter their BOOST plans and actions without
            the ability to undo your changes. All changes will also be recorded under your corporate login.`}
        </Typography>
      </div>
    </div>
  );
};

export default AccessBanner;
